<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header
          v-if="this.tableDataFiltered.length == 0"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Laden</h4>
        </md-card-header>
        <md-card-header
          v-if="this.tableDataFiltered.length > 0"
          class="md-card-header-icon md-card-header-green"
        >
          <div class="card-icon">
            <md-icon>email</md-icon>
          </div>
          <h4 class="title">E-mail log</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            v-if="this.tableDataFiltered.length > 0"
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="sortAll"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">Log regels per pagina</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                    {{ item }}
                  </md-option>
                </md-select>
              </md-field>

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Zoek email(s)"
                  v-model="searchQuery"
                >
                </md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Aangemaakt" md-sort-by="created_at">
                {{ formatDateTime(item.created_at) }}
              </md-table-cell>
              <md-table-cell md-label="Laatste update" md-sort-by="updated_at">
                {{ formatDateTime(item.updated_at) }}
              </md-table-cell>
              <md-table-cell md-label="Status" md-sort-by="status_label">
                {{ item.status_label }}
              </md-table-cell>
              <md-table-cell md-label="Ontvanger" md-sort-by="toEmail">
                {{ item.toEmail }}
              </md-table-cell>
              <md-table-cell md-label="Onderwerp" md-sort-by="subject">
                {{ item.subject }}
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions
          v-if="this.tableDataFiltered.length > 0"
          md-alignment="space-between"
        >
          <div class="">
            <p class="card-category">
              Weergave van {{ from + 1 }} t/m {{ to }} van {{ total }} emails
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          >
          </pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";

export default {
  components: {
    Pagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableDataFiltered;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDataFiltered.length;
    },
    nextYear() {
      return new Date().getFullYear() + 1;
    },
    tableDataFiltered: function() {
      var data = [];
      for (var i in this.tableData) {
        data.push(this.tableData[i]);
      }

      return data;
    }
  },
  data() {
    return {
      currentSort: "created_at",
      currentSortOrder: "desc",
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100, 200, 500],
        total: 0
      },
      searchQuery: "",
      propsToSearch: [
        "created_at",
        "updated_at",
        "toEmail",
        "subject",
        "status_label"
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      timestampNow: Math.floor(Date.now() / 1000)
    };
  },
  methods: {
    formatDateTime(dateTime) {
      if (typeof dateTime !== "string" || dateTime === "") {
        return dateTime;
      }
      dateTime = dateTime.split(" ");
      dateTime[0] = dateTime[0].split("-");
      if (dateTime[0][0].length === 4) {
        dateTime[0] = dateTime[0].reverse();
      }
      dateTime[0] = dateTime[0].join("-");
      dateTime[1] = dateTime[1].substring(0, 8);

      return dateTime.join(" ");
    },
    loadMailLog() {
      this.$http.get(this.$apiBaseUrl + "notifications/log/mail").then(
        response => {
          this.tableData = response.data.emails;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: [
              "created_at",
              "updated_at",
              "toEmail",
              "subject",
              "status_label"
            ],
            threshold: 0.3
          });
        },
        response => {
          if (response.status === 403) {
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van e-mail logs",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    },
    getTimestampForDate(date) {
      return Math.floor(new Date(date + "T23:59:59.999+0200").getTime() / 1000);
    }
  },
  mounted() {
    this.loadMailLog();
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
.md-card .md-table-cell.cursor-pointer {
  cursor: pointer;
}
.md-card .md-table-cell.cursor-mail {
  cursor: url("/img/default/pointers/mail.svg"), auto;
}
</style>
